import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Modal, Form, Button, Alert } from 'react-bootstrap';
import apiClient from '../../../../../shared/services/apiService';
import axiosClient from '../../../../../services/axiosClient';
import Swal from 'sweetalert2';

//Images
import pic1 from './../../../images/comapny/1.png';
import pic2 from './../../../images/comapny/2.png';
import pic3 from './../../../images/comapny/3.png';
import pic4 from './../../../images/comapny/4.png';
import pic5 from './../../../images/comapny/5.png';
import pic6 from './../../../images/comapny/6.png';

// Fonction utilitaire pour lire le token du localStorage
function getAuthHeader() {
	try {
		const str = localStorage.getItem('userDetails');
		if (!str) return {};
		const { token, tokenType } = JSON.parse(str) || {};
		if (token) {
			return { Authorization: `${tokenType || 'Bearer'} ${token}` };
		}
		return {};
	} catch (_) {
		return {};
	}
}

const Companies = () => {
	const [control3, setControl3] = useState('Choose Location');
	const [salaryblog, setSalaryblog] = useState('Salary Range');
	const [selectblog, setSelectblog] = useState('Newest');
	const [companies, setCompanies] = useState([]);
	const [filteredCompanies, setFilteredCompanies] = useState([]);
	const [loading, setLoading] = useState(true);
	const [searchTerm, setSearchTerm] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [recordsPerPage, setRecordsPerPage] = useState(20);
	const [cities, setCities] = useState([]);
	const [selectedCompanies, setSelectedCompanies] = useState([]);
	
	// Pagination API state
	const [totalCompanies, setTotalCompanies] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const [selectedCityId, setSelectedCityId] = useState('');
	
	// Collapse state
	const [expandedRow, setExpandedRow] = useState(null);
	const [editFormData, setEditFormData] = useState({});
	const [editLogoFile, setEditLogoFile] = useState(null);
	const [editLogoPreview, setEditLogoPreview] = useState(null);
	const [updating, setUpdating] = useState(false);
	
	// Modal state
	const [showModal, setShowModal] = useState(false);
	const [submitting, setSubmitting] = useState(false);
	const [formError, setFormError] = useState('');
	const [logoFile, setLogoFile] = useState(null);
	const [logoPreview, setLogoPreview] = useState(null);
	
	// Form data
	const [formData, setFormData] = useState({
		country_code: 'SN',
		name: '',
		description: '',
		city_id: '',
		address: '',
		phone: '',
		email: '',
		website: '',
		facebook: '',
		twitter: '',
		linkedin: ''
	});

	// Fetch cities from API
	useEffect(() => {
		const fetchCities = async () => {
			try {
				const response = await axiosClient.get('/countries/SN/cities?perPage=100', {
					headers: { 
						'Accept': 'application/json',
						...getAuthHeader() 
					},
				});
				
				if (response.status === 200) {
					const data = response.data;
					let cityList = data?.result?.data || data?.data || data?.result || data || [];
					if (!Array.isArray(cityList)) {
						if (cityList && Array.isArray(cityList.data)) cityList = cityList.data;
						else cityList = [];
					}
					
					// Normaliser les données des villes
					const normalizedCities = cityList.map(city => ({
						id: city.id,
						name: city.name,
						country_code: city.country_code,
						posts_count: city.posts_count || 0
					}));
					
					// Trier par nombre de posts décroissant
					normalizedCities.sort((a, b) => b.posts_count - a.posts_count);
					
					setCities(normalizedCities);
					console.log('[Companies] Cities loaded:', normalizedCities.length);
				}
			} catch (e) {
				console.error('[Companies] Cities API fetch error:', e);
				// Fallback avec villes par défaut
				setCities([
					{ id: 1, name: 'Dakar', country_code: 'SN', posts_count: 0 },
					{ id: 2, name: 'Thiès', country_code: 'SN', posts_count: 0 },
					{ id: 3, name: 'Saint-Louis', country_code: 'SN', posts_count: 0 },
					{ id: 4, name: 'Kaolack', country_code: 'SN', posts_count: 0 }
				]);
			}
		};
		fetchCities();
	}, []);

	// Fetch companies from API with pagination
	useEffect(() => {
		const fetchCompanies = async () => {
			try {
				setLoading(true);
				
				// Construire les paramètres de l'API
				const params = {
					page: currentPage,
					perPage: recordsPerPage
				};
				
				// Ajouter le filtre de ville si sélectionné
				if (selectedCityId) {
					params.city_id = selectedCityId;
				}
				
				console.log('[Companies] Fetching with params:', params);
				const response = await apiClient.get('/companies', { params });
				console.log('[Companies] API Response:', response);
				
				// Extraire les données de pagination
				const result = response?.data?.result || response?.data;
				const companiesData = result?.data || [];
				const paginationData = result?.paginator || result?.meta || {};
				
				console.log('[Companies] Companies data:', companiesData);
				console.log('[Companies] Pagination data:', paginationData);
				
				setCompanies(companiesData);
				setFilteredCompanies(companiesData);
				
				// Mettre à jour les informations de pagination
				setTotalCompanies(paginationData.total || companiesData.length);
				setTotalPages(paginationData.lastPage || paginationData.last_page || Math.ceil((paginationData.total || companiesData.length) / recordsPerPage));
				
			} catch (err) {
				console.error('[Companies] Error fetching companies:', err);
				console.error('[Companies] Error details:', err?.response?.data);
			} finally {
				setLoading(false);
			}
		};
		fetchCompanies();
	}, [currentPage, recordsPerPage, selectedCityId]);

	// Filter companies based on search (client-side for current page)
	useEffect(() => {
		let filtered = [...companies];

		// Search filter (client-side sur la page actuelle)
		if (searchTerm) {
			filtered = filtered.filter(company =>
				company.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
				company.description?.toLowerCase().includes(searchTerm.toLowerCase())
			);
		}

		// Sort
		if (selectblog === 'Newest') {
			filtered.sort((a, b) => b.id - a.id);
		} else if (selectblog === 'Oldest') {
			filtered.sort((a, b) => a.id - b.id);
		}

		setFilteredCompanies(filtered);
	}, [searchTerm, selectblog, companies]);
	
	// Gérer le changement de ville (réinitialiser la page)
	useEffect(() => {
		if (control3 !== 'Choose Location') {
			const selectedCity = cities.find(city => city.name === control3);
			if (selectedCity) {
				setSelectedCityId(selectedCity.id);
				setCurrentPage(1);
			}
		} else {
			setSelectedCityId('');
			setCurrentPage(1);
		}
	}, [control3, cities]);

	// Pagination (utilise les données de l'API)
	const indexOfLastRecord = currentPage * recordsPerPage;
	const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
	const currentRecords = filteredCompanies; // Pas de slice car les données viennent déjà paginées de l'API

	const handleSearch = () => {
		// Search is already handled by useEffect
		console.log('[Companies] Search triggered');
	};

	return(
		<>
			{/* Header */}
			<div className="row mb-4">
				<div className="col-12">
					<div className="d-flex justify-content-between align-items-center flex-wrap">
						<div>
							<h2 className="mb-1" style={{ fontSize: '28px', fontWeight: '700' }}>Entreprises</h2>
							<p className="text-muted mb-0">
								Affichage des éléments {indexOfFirstRecord + 1} à {Math.min(indexOfLastRecord, totalCompanies)} sur {totalCompanies}
							</p>
						</div>
						<div className="d-flex gap-2">
							<button 
								className="btn btn-primary btn-sm"
								onClick={() => setShowModal(true)}
								style={{ borderRadius: '6px' }}
							>
								<i className="fas fa-plus me-2"></i>Créer une entreprise
							</button>
							<button 
								className="btn btn-danger btn-sm"
								disabled={selectedCompanies.length === 0}
								onClick={() => {
									if (window.confirm(`Supprimer ${selectedCompanies.length} entreprise(s) ?`)) {
										setCompanies(companies.filter(c => !selectedCompanies.includes(c.id)));
										setSelectedCompanies([]);
									}
								}}
								style={{ borderRadius: '6px' }}
							>
								<i className="fas fa-times me-2"></i>Delete
							</button>
						</div>
					</div>
				</div>
			</div>

			{/* Filters */}
			<div className="row mb-4">
				<div className="col-12">
					<div className="card" style={{ border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: '12px' }}>
						<div className="card-body">
							<div className="row align-items-center g-3">
								<div className="col-md-3">
									<Dropdown>
										<Dropdown.Toggle variant="outline-secondary" className="w-100 text-start d-flex justify-content-between align-items-center" style={{ borderRadius: '8px' }}>
											<span><i className="fas fa-filter me-2"></i>{control3}</span>
											<i className="fas fa-angle-down"></i>
										</Dropdown.Toggle>
										<Dropdown.Menu style={{ maxHeight: '300px', overflowY: 'auto', width: '100%' }}>
											<Dropdown.Item onClick={() => setControl3("Choose Location")}>
												Toutes les villes
											</Dropdown.Item>
											<Dropdown.Divider />
											{cities.map((city) => (
												<Dropdown.Item key={city.id} onClick={() => setControl3(city.name)}>
													{city.name} {city.posts_count > 0 && <span className="badge bg-secondary ms-2">{city.posts_count}</span>}
												</Dropdown.Item>
											))}
										</Dropdown.Menu>
									</Dropdown>
								</div>
								<div className="col-md-6">
									<div className="input-group">
										<span className="input-group-text bg-white" style={{ borderRadius: '8px 0 0 8px' }}>
											<i className="fas fa-search text-muted"></i>
										</span>
										<input 
											type="text" 
											className="form-control border-start-0" 
											placeholder="Rechercher une entreprise..." 
											value={searchTerm}
											onChange={(e) => setSearchTerm(e.target.value)}
											style={{ borderRadius: '0 8px 8px 0' }}
										/>
									</div>
								</div>
								<div className="col-md-3">
									<select 
										className="form-select"
										value={recordsPerPage}
										onChange={(e) => {
											setRecordsPerPage(Number(e.target.value));
											setCurrentPage(1); // Réinitialiser à la page 1 lors du changement
										}}
										style={{ borderRadius: '8px' }}
									>
										<option value={10}>10 par page</option>
										<option value={20}>20 par page</option>
										<option value={50}>50 par page</option>
										<option value={100}>100 par page</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Table */}
			<div className="row">
				<div className="col-12">
					<div className="card" style={{ border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: '12px' }}>
						<div className="card-body p-0">
							{loading ? (
								<div className="text-center py-5">
									<div className="spinner-border text-primary" role="status">
										<span className="visually-hidden">Loading...</span>
									</div>
								</div>
							) : currentRecords.length === 0 ? (
								<div className="text-center py-5">
									<p className="text-muted">Aucune entreprise trouvée</p>
								</div>
							) : (
								<div className="table-responsive">
									<table className="table table-hover mb-0" style={{ minWidth: '800px' }}>
										<thead style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
											<tr>
												<th style={{ padding: '16px', width: '50px' }}>
													<input 
														type="checkbox" 
														className="form-check-input"
														onChange={(e) => {
															if (e.target.checked) {
																setSelectedCompanies(currentRecords.map(c => c.id));
															} else {
																setSelectedCompanies([]);
															}
														}}
														checked={selectedCompanies.length === currentRecords.length && currentRecords.length > 0}
													/>
												</th>
												<th style={{ padding: '16px', fontWeight: '600', fontSize: '14px' }}>Logo</th>
												<th style={{ padding: '16px', fontWeight: '600', fontSize: '14px' }}>
													<div className="d-flex align-items-center">
														Name
														<i className="fas fa-sort ms-2 text-muted" style={{ fontSize: '12px', cursor: 'pointer' }}></i>
													</div>
												</th>
												<th style={{ padding: '16px', fontWeight: '600', fontSize: '14px' }}>Description</th>
												<th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', textAlign: 'center' }}>Jobs</th>
											</tr>
										</thead>
										<tbody>
											{currentRecords.map((company) => (
												<React.Fragment key={company.id}>
													<tr 
														style={{ 
															borderBottom: expandedRow === company.id ? 'none' : '1px solid #f0f0f0',
															transition: 'background-color 0.2s',
															cursor: 'pointer',
															backgroundColor: expandedRow === company.id ? '#f8f9fa' : 'transparent'
														}}
														onClick={() => {
															if (expandedRow === company.id) {
																setExpandedRow(null);
																setEditFormData({});
																setEditLogoFile(null);
																setEditLogoPreview(null);
															} else {
																setExpandedRow(company.id);
																setEditFormData({
																	country_code: company.country_code || 'SN',
																	name: company.name || '',
																	description: company.description || '',
																	city_id: typeof company.city_id === 'object' 
																		? company.city_id?.id || company.city_id?.value || ''
																		: String(company.city_id || ''),
																	address: company.address || '',
																	phone: company.phone || '',
																	email: company.email || '',
																	website: company.website || '',
																	facebook: company.facebook || '',
																	twitter: company.twitter || '',
																	linkedin: company.linkedin || ''
																});
																setEditLogoPreview(company.logo_url?.medium || null);
															}
														}}
														onMouseEnter={(e) => {
															if (expandedRow !== company.id) {
																e.currentTarget.style.backgroundColor = '#f8f9fa';
															}
														}}
														onMouseLeave={(e) => {
															if (expandedRow !== company.id) {
																e.currentTarget.style.backgroundColor = 'transparent';
															}
														}}
													>
														<td style={{ padding: '16px', verticalAlign: 'middle' }} onClick={(e) => e.stopPropagation()}>
															<input 
																type="checkbox" 
																className="form-check-input"
																checked={selectedCompanies.includes(company.id)}
																onChange={() => {
																	if (selectedCompanies.includes(company.id)) {
																		setSelectedCompanies(selectedCompanies.filter(id => id !== company.id));
																	} else {
																		setSelectedCompanies([...selectedCompanies, company.id]);
																	}
																}}
															/>
														</td>
														<td style={{ padding: '16px', verticalAlign: 'middle' }}>
															<div 
																style={{
																	width: '50px',
																	height: '50px',
																	borderRadius: '8px',
																	overflow: 'hidden',
																	background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center'
																}}
															>
																{company.logo_url?.small ? (
																	<img 
																		src={company.logo_url.small.replace('https://localhost:8000', 'https://update.senoffre.com')} 
																		alt={company.name}
																		style={{ width: '100%', height: '100%', objectFit: 'cover' }}
																	/>
																) : (
																	<span style={{ fontSize: '20px', color: '#fff', fontWeight: '700' }}>
																		{company.name?.charAt(0) || 'C'}
																	</span>
																)}
															</div>
														</td>
														<td style={{ padding: '16px', verticalAlign: 'middle' }}>
															<div>
																<span 
																	style={{ 
																		color: '#145650', 
																		fontWeight: '600', 
																		fontSize: '15px'
																	}}
																>
																	{company.name}
																</span>
																<div style={{ fontSize: '13px', color: '#145650', marginTop: '4px' }}>
																	{company.posts_count || 0} emplois
																</div>
															</div>
														</td>
														<td style={{ padding: '16px', verticalAlign: 'middle', maxWidth: '400px' }}>
															<div 
																style={{ 
																	fontSize: '14px', 
																	color: '#145650',
																	overflow: 'hidden',
																	textOverflow: 'ellipsis',
																	display: '-webkit-box',
																	WebkitLineClamp: 2,
																	WebkitBoxOrient: 'vertical',
																	lineHeight: '1.5'
																}}
															>
																{company.description || 'Aucune description disponible'}
															</div>
														</td>
														<td style={{ padding: '16px', verticalAlign: 'middle', textAlign: 'center' }}>
															<span 
																className="badge"
																style={{
																	background: company.posts_count > 0 ? 'linear-gradient(135deg, #145650 0%, #0d3d39 100%)' : '#e9ecef',
																	color: company.posts_count > 0 ? '#fff' : '#6c757d',
																	padding: '6px 12px',
																	borderRadius: '20px',
																	fontSize: '13px',
																	fontWeight: '600'
																}}
															>
																{company.posts_count || 0}
															</span>
														</td>
													</tr>
													{expandedRow === company.id && (
														<tr>
															<td colSpan="5" style={{ padding: '0', backgroundColor: '#f8f9fa', borderBottom: '1px solid #f0f0f0' }}>
																<div style={{ padding: '24px' }}>
																	{renderEditForm(company)}
																</div>
															</td>
														</tr>
													)}
												</React.Fragment>
											))}
										</tbody>
									</table>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>	
			{totalCompanies > 0 && (
				<div className="d-flex align-items-center justify-content-between flex-wrap mt-4">
					<div className="sm-mb-0 mb-0">
						<p className="text-muted mb-0" style={{ fontSize: '14px' }}>
							Affichage de {indexOfFirstRecord + 1} à {Math.min(indexOfLastRecord, totalCompanies)} sur {totalCompanies} entreprises
						</p>
					</div>
					{totalPages > 1 && (
						<nav>
							<ul className="pagination pagination-circle">
								{/* Previous Button */}
								<li className={`page-item page-indicator ${currentPage === 1 ? 'disabled' : ''}`}>
									<button 
										type="button"
										className="page-link"
										onClick={() => setCurrentPage(currentPage - 1)}
										disabled={currentPage === 1}
									>
										<i className="la la-angle-left" />
									</button>
								</li>

								{/* Page Numbers */}
								{(() => {
									const pages = [];
									const showEllipsisStart = currentPage > 3;
									const showEllipsisEnd = currentPage < totalPages - 2;

									// Always show first page
									pages.push(
										<li key={1} className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
											<button 
												type="button"
												className="page-link"
												onClick={() => setCurrentPage(1)}
											>
												1
											</button>
										</li>
									);

									// Show ellipsis after first page if needed
									if (showEllipsisStart) {
										pages.push(
											<li key="ellipsis-start" className="page-item disabled">
												<span className="page-link">...</span>
											</li>
										);
									}

									// Show pages around current page
									const startPage = Math.max(2, currentPage - 1);
									const endPage = Math.min(totalPages - 1, currentPage + 1);

									for (let i = startPage; i <= endPage; i++) {
										pages.push(
											<li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
												<button 
													type="button"
													className="page-link"
													onClick={() => setCurrentPage(i)}
												>
													{i}
												</button>
											</li>
										);
									}

									// Show ellipsis before last page if needed
									if (showEllipsisEnd) {
										pages.push(
											<li key="ellipsis-end" className="page-item disabled">
												<span className="page-link">...</span>
											</li>
										);
									}

									// Always show last page if there's more than 1 page
									if (totalPages > 1) {
										pages.push(
											<li key={totalPages} className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
												<button 
													type="button"
													className="page-link"
													onClick={() => setCurrentPage(totalPages)}
												>
													{totalPages}
												</button>
											</li>
										);
									}

									return pages;
								})()}

								{/* Next Button */}
								<li className={`page-item page-indicator ${currentPage === totalPages ? 'disabled' : ''}`}>
									<button 
										type="button"
										className="page-link"
										onClick={() => setCurrentPage(currentPage + 1)}
										disabled={currentPage === totalPages}
									>
										<i className="la la-angle-right" />
									</button>
								</li>
							</ul>
						</nav>
					)}
				</div>
			)}
			
			{/* Modal de création d'entreprise */}
			<Modal 
				show={showModal} 
				onHide={() => !submitting && setShowModal(false)} 
				centered
				dialogClassName="modal-90w"
			>
				<Modal.Header closeButton style={{ borderBottom: '2px solid #f0f0f0' }}>
					<Modal.Title style={{ fontSize: '24px', fontWeight: '700', color: '#145650' }}>
						<i className="fas fa-building me-2"></i>
						Créer une nouvelle entreprise
					</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ padding: '2rem' }}>
					{formError && (
						<Alert variant="danger" onClose={() => setFormError('')} dismissible>
							{formError}
						</Alert>
					)}
					
					<Form>
						{/* Logo Upload */}
						<div className="mb-4 text-center">
							<div 
								style={{
									width: '120px',
									height: '120px',
									margin: '0 auto 1rem',
									borderRadius: '12px',
									border: '3px dashed #145650',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									backgroundImage: logoPreview ? `url(${logoPreview})` : 'none',
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									cursor: 'pointer',
									position: 'relative',
									overflow: 'hidden'
								}}
								onClick={() => document.getElementById('logoInput').click()}
							>
								{!logoPreview && (
									<div style={{ textAlign: 'center', color: '#145650' }}>
										<i className="fas fa-cloud-upload-alt" style={{ fontSize: '32px', marginBottom: '8px' }}></i>
										<div style={{ fontSize: '12px' }}>Cliquer pour uploader</div>
									</div>
								)}
							</div>
							<input 
								id="logoInput"
								type="file" 
								accept="image/*"
								style={{ display: 'none' }}
								onChange={(e) => {
									const file = e.target.files[0];
									if (file) {
										if (file.size > 5 * 1024 * 1024) {
											setFormError('Le fichier est trop volumineux (max 5MB)');
											return;
										}
										setLogoFile(file);
										const reader = new FileReader();
										reader.onloadend = () => setLogoPreview(reader.result);
										reader.readAsDataURL(file);
									}
								}}
							/>
							<small className="text-muted">Logo de l'entreprise (max 5MB)</small>
						</div>
						
						{/* Informations de base */}
						<h5 style={{ color: '#145650', marginBottom: '1rem', fontSize: '16px', fontWeight: '600' }}>
							<i className="fas fa-info-circle me-2"></i>Informations de base
						</h5>
						
						<Form.Group className="mb-3">
							<Form.Label>Nom de l'entreprise <span className="text-danger">*</span></Form.Label>
							<Form.Control 
								type="text" 
								placeholder="Ex: SENELEC"
								value={formData.name}
								onChange={(e) => setFormData({...formData, name: e.target.value})}
								required
								style={{ borderRadius: '8px' }}
							/>
						</Form.Group>
						
						<Form.Group className="mb-3">
							<Form.Label>Description <span className="text-danger">*</span></Form.Label>
							<Form.Control 
								as="textarea" 
								rows={3}
								placeholder="Description de l'entreprise..."
								value={formData.description}
								onChange={(e) => setFormData({...formData, description: e.target.value})}
								required
								style={{ borderRadius: '8px' }}
							/>
						</Form.Group>
						
						<Form.Group className="mb-3">
							<Form.Label>Ville</Form.Label>
							<Form.Select 
								value={formData.city_id}
								onChange={(e) => setFormData({...formData, city_id: e.target.value})}
								style={{ borderRadius: '8px' }}
							>
								<option value="">Sélectionner une ville</option>
								{cities.map(city => (
									<option key={city.id} value={city.id}>{city.name}</option>
								))}
							</Form.Select>
						</Form.Group>
						
						<Form.Group className="mb-4">
							<Form.Label>Adresse</Form.Label>
							<Form.Control 
								type="text" 
								placeholder="Ex: Rue de la République, Dakar"
								value={formData.address}
								onChange={(e) => setFormData({...formData, address: e.target.value})}
								style={{ borderRadius: '8px' }}
							/>
						</Form.Group>
						
						{/* Contact */}
						<h5 style={{ color: '#145650', marginBottom: '1rem', fontSize: '16px', fontWeight: '600' }}>
							<i className="fas fa-phone me-2"></i>Contact
						</h5>
						
						<div className="row">
							<div className="col-md-6">
								<Form.Group className="mb-3">
									<Form.Label>Téléphone</Form.Label>
									<Form.Control 
										type="tel" 
										placeholder="+221338391000"
										value={formData.phone}
										onChange={(e) => setFormData({...formData, phone: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
							<div className="col-md-6">
								<Form.Group className="mb-3">
									<Form.Label>Email</Form.Label>
									<Form.Control 
										type="email" 
										placeholder="contact@entreprise.sn"
										value={formData.email}
										onChange={(e) => setFormData({...formData, email: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
						</div>
						
						<Form.Group className="mb-4">
							<Form.Label>Site web</Form.Label>
							<Form.Control 
								type="url" 
								placeholder="https://www.entreprise.sn"
								value={formData.website}
								onChange={(e) => setFormData({...formData, website: e.target.value})}
								style={{ borderRadius: '8px' }}
							/>
						</Form.Group>
						
						{/* Réseaux sociaux */}
						<h5 style={{ color: '#145650', marginBottom: '1rem', fontSize: '16px', fontWeight: '600' }}>
							<i className="fas fa-share-alt me-2"></i>Réseaux sociaux
						</h5>
						
						<Form.Group className="mb-3">
							<Form.Label><i className="fab fa-facebook me-2" style={{color: '#145650'}}></i>Facebook</Form.Label>
							<Form.Control 
								type="url" 
								placeholder="https://facebook.com/entreprise"
								value={formData.facebook}
								onChange={(e) => setFormData({...formData, facebook: e.target.value})}
								style={{ borderRadius: '8px' }}
							/>
						</Form.Group>
						
						<Form.Group className="mb-3">
							<Form.Label><i className="fab fa-twitter me-2" style={{color: '#145650'}}></i>Twitter</Form.Label>
							<Form.Control 
								type="url" 
								placeholder="https://twitter.com/entreprise"
								value={formData.twitter}
								onChange={(e) => setFormData({...formData, twitter: e.target.value})}
								style={{ borderRadius: '8px' }}
							/>
						</Form.Group>
						
						<Form.Group className="mb-3">
							<Form.Label><i className="fab fa-linkedin me-2" style={{color: '#145650'}}></i>LinkedIn</Form.Label>
							<Form.Control 
								type="url" 
								placeholder="https://linkedin.com/company/entreprise"
								value={formData.linkedin}
								onChange={(e) => setFormData({...formData, linkedin: e.target.value})}
								style={{ borderRadius: '8px' }}
							/>
						</Form.Group>
					</Form>
				</Modal.Body>
				<Modal.Footer style={{ borderTop: '2px solid #f0f0f0', padding: '1.5rem' }}>
					<Button 
						variant="secondary" 
						onClick={() => setShowModal(false)}
						disabled={submitting}
						style={{ borderRadius: '8px' }}
					>
						Annuler
					</Button>
					<Button 
						variant="primary" 
						onClick={handleCreateCompany}
						disabled={submitting || !formData.name || !formData.description}
						style={{ 
							background: 'linear-gradient(135deg, #145650 0%, #0d3d39 100%)',
							border: 'none',
							borderRadius: '8px'
						}}
					>
						{submitting ? (
							<>
								<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
								Création en cours...
							</>
						) : (
							<>
								<i className="fas fa-check me-2"></i>
								Créer l'entreprise
							</>
						)}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
	
	// Fonction pour afficher le formulaire de modification
	function renderEditForm(company) {
		return (
			<div className="row">
				<div className="col-md-8">
					<Form>
						{/* Logo Upload */}
						<div className="mb-3">
							<Form.Label style={{ fontWeight: '600', color: '#145650' }}>Logo de l'entreprise</Form.Label>
							<div className="d-flex align-items-center gap-3">
								<div 
									style={{
										width: '80px',
										height: '80px',
										borderRadius: '8px',
										border: '2px dashed #145650',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										backgroundImage: editLogoPreview ? `url(${editLogoPreview})` : 'none',
										backgroundSize: 'cover',
										backgroundPosition: 'center',
										cursor: 'pointer',
										overflow: 'hidden'
									}}
									onClick={() => document.getElementById(`editLogoInput-${company.id}`).click()}
								>
									{!editLogoPreview && (
										<i className="fas fa-camera" style={{ fontSize: '24px', color: '#145650' }}></i>
									)}
								</div>
								<input 
									id={`editLogoInput-${company.id}`}
									type="file" 
									accept="image/*"
									style={{ display: 'none' }}
									onChange={(e) => {
										const file = e.target.files[0];
										if (file) {
											if (file.size > 5 * 1024 * 1024) {
												Swal.fire({
													icon: 'error',
													title: 'Erreur',
													text: 'Le fichier est trop volumineux (max 5MB)',
													confirmButtonColor: '#dc3545'
												});
												return;
											}
											setEditLogoFile(file);
											const reader = new FileReader();
											reader.onloadend = () => setEditLogoPreview(reader.result);
											reader.readAsDataURL(file);
										}
									}}
								/>
								<small className="text-muted">Cliquer pour changer le logo (max 5MB)</small>
							</div>
						</div>

						<div className="row">
							<div className="col-md-6">
								<Form.Group className="mb-3">
									<Form.Label>Nom de l'entreprise <span className="text-danger">*</span></Form.Label>
									<Form.Control 
										type="text" 
										value={editFormData.name || ''}
										onChange={(e) => setEditFormData({...editFormData, name: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
							<div className="col-md-6">
								<Form.Group className="mb-3">
									<Form.Label>Ville</Form.Label>
									<Form.Select 
										value={editFormData.city_id || ''}
										onChange={(e) => setEditFormData({...editFormData, city_id: e.target.value})}
										style={{ borderRadius: '8px' }}
									>
										<option value="">Sélectionner une ville</option>
										{cities.map(city => (
											<option key={city.id} value={city.id}>{city.name}</option>
										))}
									</Form.Select>
								</Form.Group>
							</div>
						</div>

						<Form.Group className="mb-3">
							<Form.Label>Description <span className="text-danger">*</span></Form.Label>
							<Form.Control 
								as="textarea" 
								rows={2}
								value={editFormData.description || ''}
								onChange={(e) => setEditFormData({...editFormData, description: e.target.value})}
								style={{ borderRadius: '8px' }}
							/>
						</Form.Group>

						<div className="row">
							<div className="col-md-6">
								<Form.Group className="mb-3">
									<Form.Label>Téléphone</Form.Label>
									<Form.Control 
										type="tel" 
										value={editFormData.phone || ''}
										onChange={(e) => setEditFormData({...editFormData, phone: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
							<div className="col-md-6">
								<Form.Group className="mb-3">
									<Form.Label>Email</Form.Label>
									<Form.Control 
										type="email" 
										value={editFormData.email || ''}
										onChange={(e) => setEditFormData({...editFormData, email: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
						</div>

						<div className="row">
							<div className="col-md-6">
								<Form.Group className="mb-3">
									<Form.Label>Site web</Form.Label>
									<Form.Control 
										type="url" 
										value={editFormData.website || ''}
										onChange={(e) => setEditFormData({...editFormData, website: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
							<div className="col-md-6">
								<Form.Group className="mb-3">
									<Form.Label>Adresse</Form.Label>
									<Form.Control 
										type="text" 
										value={editFormData.address || ''}
										onChange={(e) => setEditFormData({...editFormData, address: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
						</div>

						<div className="row">
							<div className="col-md-4">
								<Form.Group className="mb-3">
									<Form.Label><i className="fab fa-facebook me-2" style={{color: '#145650'}}></i>Facebook</Form.Label>
									<Form.Control 
										type="url" 
										value={editFormData.facebook || ''}
										onChange={(e) => setEditFormData({...editFormData, facebook: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
							<div className="col-md-4">
								<Form.Group className="mb-3">
									<Form.Label><i className="fab fa-twitter me-2" style={{color: '#145650'}}></i>Twitter</Form.Label>
									<Form.Control 
										type="url" 
										value={editFormData.twitter || ''}
										onChange={(e) => setEditFormData({...editFormData, twitter: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
							<div className="col-md-4">
								<Form.Group className="mb-3">
									<Form.Label><i className="fab fa-linkedin me-2" style={{color: '#145650'}}></i>LinkedIn</Form.Label>
									<Form.Control 
										type="url" 
										value={editFormData.linkedin || ''}
										onChange={(e) => setEditFormData({...editFormData, linkedin: e.target.value})}
										style={{ borderRadius: '8px' }}
									/>
								</Form.Group>
							</div>
						</div>
					</Form>
				</div>
				<div className="col-md-4">
					<div className="d-flex flex-column gap-3">
						<Button 
							variant="primary" 
							onClick={() => handleUpdateCompany(company.id)}
							disabled={updating || !editFormData.name || !editFormData.description}
							style={{ 
								background: 'linear-gradient(135deg, #145650 0%, #0d3d39 100%)',
								border: 'none',
								borderRadius: '8px',
								padding: '12px',
								fontWeight: '600'
							}}
						>
							{updating ? (
								<>
									<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									Mise à jour en cours...
								</>
							) : (
								<>
									<i className="fas fa-save me-2"></i>
									Mise à jour
								</>
							)}
						</Button>
						<Button 
							variant="danger" 
							onClick={() => handleDeleteCompany(company.id)}
							disabled={updating}
							style={{ 
								borderRadius: '8px',
								padding: '12px',
								fontWeight: '600'
							}}
						>
							<i className="fas fa-trash me-2"></i>
							Supprimer
						</Button>
						<Button 
							variant="secondary" 
							onClick={() => {
								setExpandedRow(null);
								setEditFormData({});
								setEditLogoFile(null);
								setEditLogoPreview(null);
							}}
							disabled={updating}
							style={{ 
								borderRadius: '8px',
								padding: '12px',
								fontWeight: '600'
							}}
						>
							<i className="fas fa-times me-2"></i>
							Annuler
						</Button>
					</div>
				</div>
			</div>
		);
	}
	
	// Fonction pour mettre à jour une entreprise (POST avec _method=PUT)
	async function handleUpdateCompany(companyId) {
		if (!editFormData.name || !editFormData.description) {
			await Swal.fire({
				icon: 'error',
				title: 'Erreur',
				text: 'Veuillez remplir tous les champs obligatoires',
				confirmButtonColor: '#dc3545'
			});
			return;
		}
		
		setUpdating(true);
		
		try {
			// Préparer les données en FormData pour l'upload multipart
			const formDataToSend = new FormData();
			formDataToSend.append('_method', 'PUT'); // Méthode PUT via POST
			formDataToSend.append('company[country_code]', editFormData.country_code);
			formDataToSend.append('company[name]', editFormData.name);
			formDataToSend.append('company[description]', editFormData.description);
			
			if (editLogoFile) {
				formDataToSend.append('company[logo]', editLogoFile);
			}
			
			// S'assurer que city_id est une chaîne de caractères
			const cityIdValue = typeof editFormData.city_id === 'object' 
				? editFormData.city_id?.id || editFormData.city_id?.value || ''
				: String(editFormData.city_id || '');
			
			if (cityIdValue) formDataToSend.append('company[city_id]', cityIdValue);
			if (editFormData.address) formDataToSend.append('company[address]', editFormData.address);
			if (editFormData.phone) formDataToSend.append('company[phone]', editFormData.phone);
			if (editFormData.email) formDataToSend.append('company[email]', editFormData.email);
			if (editFormData.website) formDataToSend.append('company[website]', editFormData.website);
			if (editFormData.facebook) formDataToSend.append('company[facebook]', editFormData.facebook);
			if (editFormData.twitter) formDataToSend.append('company[twitter]', editFormData.twitter);
			if (editFormData.linkedin) formDataToSend.append('company[linkedin]', editFormData.linkedin);
			
			// Appel API POST avec _method=PUT
			const response = await axiosClient.post(`/companies/${companyId}`, formDataToSend, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'Accept': 'application/json',
					...getAuthHeader()
				}
			});
			
			console.log('[Companies] Update Response:', response);
			
			// Fermer le collapse
			setExpandedRow(null);
			setEditFormData({});
			setEditLogoFile(null);
			setEditLogoPreview(null);
			
			// Afficher le message de succès
			await Swal.fire({
				icon: 'success',
				title: 'Succès !',
				text: response.data?.message || 'Entreprise mise à jour avec succès',
				confirmButtonColor: '#145650'
			});
			
			// Recharger la liste des entreprises
			try {
				const params = {
					page: currentPage,
					perPage: recordsPerPage
				};
				if (selectedCityId) {
					params.city_id = selectedCityId;
				}
				const companiesResponse = await apiClient.get('/companies', { params });
				const result = companiesResponse?.data?.result || companiesResponse?.data;
				const companiesData = result?.data || [];
				setCompanies(companiesData);
				setFilteredCompanies(companiesData);
			} catch (reloadError) {
				console.error('[Companies] Error reloading companies:', reloadError);
			}
		} catch (error) {
			console.error('[Companies] Error updating company:', error);
			const errorMessage = error.response?.data?.message || error.message || 'Erreur lors de la mise à jour de l\'entreprise';
			
			await Swal.fire({
				icon: 'error',
				title: 'Erreur',
				text: errorMessage,
				confirmButtonColor: '#dc3545'
			});
		} finally {
			setUpdating(false);
		}
	}
	
	// Fonction pour supprimer une entreprise
	async function handleDeleteCompany(companyId) {
		const result = await Swal.fire({
			icon: 'warning',
			title: 'Êtes-vous sûr ?',
			text: 'Cette action est irréversible !',
			showCancelButton: true,
			confirmButtonColor: '#dc3545',
			cancelButtonColor: '#6c757d',
			confirmButtonText: 'Oui, supprimer',
			cancelButtonText: 'Annuler'
		});
		
		if (!result.isConfirmed) {
			return;
		}
		
		setUpdating(true);
		
		try {
			await axiosClient.delete(`/companies/${companyId}`, {
				headers: {
					'Accept': 'application/json',
					...getAuthHeader()
				}
			});
			
			// Fermer le collapse
			setExpandedRow(null);
			setEditFormData({});
			setEditLogoFile(null);
			setEditLogoPreview(null);
			
			// Afficher le message de succès
			await Swal.fire({
				icon: 'success',
				title: 'Supprimé !',
				text: 'L\'entreprise a été supprimée avec succès',
				confirmButtonColor: '#145650'
			});
			
			// Recharger la liste des entreprises
			try {
				const params = {
					page: currentPage,
					perPage: recordsPerPage
				};
				if (selectedCityId) {
					params.city_id = selectedCityId;
				}
				const companiesResponse = await apiClient.get('/companies', { params });
				const result = companiesResponse?.data?.result || companiesResponse?.data;
				const companiesData = result?.data || [];
				setCompanies(companiesData);
				setFilteredCompanies(companiesData);
			} catch (reloadError) {
				console.error('[Companies] Error reloading companies:', reloadError);
			}
		} catch (error) {
			console.error('[Companies] Error deleting company:', error);
			const errorMessage = error.response?.data?.message || error.message || 'Erreur lors de la suppression de l\'entreprise';
			
			await Swal.fire({
				icon: 'error',
				title: 'Erreur',
				text: errorMessage,
				confirmButtonColor: '#dc3545'
			});
		} finally {
			setUpdating(false);
		}
	}
	
	// Fonction pour créer une entreprise
	async function handleCreateCompany() {
		if (!formData.name || !formData.description) {
			setFormError('Veuillez remplir tous les champs obligatoires');
			return;
		}
		
		setSubmitting(true);
		setFormError('');
		
		try {
			// Préparer les données en FormData pour l'upload multipart
			const formDataToSend = new FormData();
			formDataToSend.append('company[country_code]', formData.country_code);
			formDataToSend.append('company[name]', formData.name);
			formDataToSend.append('company[description]', formData.description);
			
			if (logoFile) {
				formDataToSend.append('company[logo]', logoFile);
			}
			
			if (formData.city_id) formDataToSend.append('company[city_id]', formData.city_id);
			if (formData.address) formDataToSend.append('company[address]', formData.address);
			if (formData.phone) formDataToSend.append('company[phone]', formData.phone);
			if (formData.email) formDataToSend.append('company[email]', formData.email);
			if (formData.website) formDataToSend.append('company[website]', formData.website);
			if (formData.facebook) formDataToSend.append('company[facebook]', formData.facebook);
			if (formData.twitter) formDataToSend.append('company[twitter]', formData.twitter);
			if (formData.linkedin) formDataToSend.append('company[linkedin]', formData.linkedin);
			
			// Appel API avec axiosClient pour utiliser l'URL de production
			const response = await axiosClient.post('/companies', formDataToSend, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'Accept': 'application/json',
					...getAuthHeader()
				}
			});
			
			console.log('[Companies] API Response:', response);
		
		// Fermer le modal IMMÉDIATEMENT
		setShowModal(false);
		setSubmitting(false);
		
		// Réinitialiser le formulaire
		setFormData({
			country_code: 'SN',
			name: '',
			description: '',
			city_id: '',
			address: '',
			phone: '',
			email: '',
			website: '',
			facebook: '',
			twitter: '',
			linkedin: ''
		});
		setLogoFile(null);
		setLogoPreview(null);
		
		// Afficher le message de succès APRÈS avoir fermé le modal
		await Swal.fire({
			icon: 'success',
			title: 'Succès !',
			text: response.data?.message || 'Entreprise créée avec succès',
			confirmButtonColor: '#145650'
		});
			
			// Recharger la liste des entreprises
			try {
				const companiesResponse = await apiClient.get('/companies');
				const companiesData = companiesResponse?.data?.result?.data || companiesResponse?.data?.data || [];
				setCompanies(companiesData);
				setFilteredCompanies(companiesData);
			} catch (reloadError) {
				console.error('[Companies] Error reloading companies:', reloadError);
			}
		} catch (error) {
			console.error('[Companies] Error creating company:', error);
			const errorMessage = error.response?.data?.message || error.message || 'Erreur lors de la création de l\'entreprise';
			setFormError(errorMessage);
			
			await Swal.fire({
				icon: 'error',
				title: 'Erreur',
				text: errorMessage,
				confirmButtonColor: '#dc3545'
			});
		} finally {
			setSubmitting(false);
		}
	}
} 
export default Companies;